import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadBookingSlotList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.post(
      `${baseUrl}/scheduler/mob/new_booking/booking_slots${
        params ? `?${params}` : ''
      }`,
      options.packageDuration,
    );
    return result.data;
  },
};
